// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2W9UB","legacyBtn":"MutateMid_legacyBtn__ND3Qr"};